import { Component, Inject, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DataService } from 'src/app/data/data.service';
import { FeedbackService } from '../feedback/feedback.service';
import { ScreenLayout, SCREEN_LAYOUT } from './layout.provider';

@Component({
    selector: 'app-layout-page',
    template: `
      <app-logout-countdown></app-logout-countdown>
      <app-desktop-layout *ngIf="useDesktop"></app-desktop-layout>
      <app-tablet-layout *ngIf="!useDesktop"></app-tablet-layout>
      <app-feedback></app-feedback>
  `,
    styles: [`
    :host {
      display: block;
    }
  `],
    standalone: false
})
export class LayoutPage implements OnDestroy {
  useDesktop = false;
  destroy = new Subject<void>();

  constructor(@Inject(SCREEN_LAYOUT) layout: ScreenLayout, dataService: DataService, feedback: FeedbackService) {
    this.useDesktop = layout === ScreenLayout.desktop;

    dataService.reservationsAndPickupsChanged.pipe(takeUntil(this.destroy)).subscribe(() => feedback.showReservationSuccess());
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
